import PureKitShareSnippet from "snippets/purekit/share";
import PureKitUnshareSnippet from "snippets/purekit/unshare";
import * as React from 'react';
export default {
  PureKitShareSnippet,
  PureKitUnshareSnippet,
  React
};